import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { MyShopState } from '../my-shop-state';
import { myShopPointOfServiceReducer } from './my-shop-point-of-service.reducer';

export type MyShopReducers = MyShopState;

export function getReducers(): ActionReducerMap<MyShopReducers> {
  return {
    pointOfService: myShopPointOfServiceReducer,
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<MyShopReducers>> = new InjectionToken<
  ActionReducerMap<MyShopReducers>
>('MyShopReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
